import React from 'react'
// import { FaUserCog, FaMicroscope, FaLaptop, FaSmile } from 'react-icons/fa'
import './WhyChooseUs.css'
import { Link } from 'react-router-dom';
import { IoCall } from "react-icons/io5";
import { IoLogoWhatsapp } from "react-icons/io";
import { MdOutlineNoteAlt } from "react-icons/md";
import { GiHotMeal } from "react-icons/gi";
import { RiChatPrivateFill } from "react-icons/ri";

export default function WhyChooseUs() {
  return (
    <main className="whychooseus-main">
      <h3 className='headingwhy'>What You Get When You Join
      </h3>
      {/* Features Section */}
      <section className="whychooseus-features">
        <div className="whychooseus-features-container">
          {/* New Cards (icon 25%, text 75%) */}
          <div className="whychooseus-features-cards">
            {/* Skilled Professionals */}
            <div className="feature-card-row">
              <div className="feature-card-icon-container">
                <IoCall className="feature-card-icon" />
              </div>
              <div className="feature-card-text">
                <h3 className="feature-card-title">Weekly Check-ins & Calls</h3>
                <p>
                Regular tracking to stay accountable and aligned
                </p>
              </div>
            </div>

            {/* Top Notch Sterilisation */}
            <div className="feature-card-row">
              <div className="feature-card-icon-container">
                <IoLogoWhatsapp className="feature-card-icon" />
              </div>
              <div className="feature-card-text">
                <h3 className="feature-card-title">24/7 WhatsApp Support</h3>
                <p>
                Ask questions anytime, no waiting
                </p>
              </div>
            </div>

            {/* State of the Art Technology */}
            <div className="feature-card-row">
              <div className="feature-card-icon-container">
                <MdOutlineNoteAlt className="feature-card-icon" />
              </div>
              <div className="feature-card-text">
                <h3 className="feature-card-title">Habit-Based Coaching</h3>
                <p>
                Build a lifestyle that sticks — no crash course nonsense
                </p>
              </div>
            </div>

            {/* Warm and Welcoming Atmosphere */}
            <div className="feature-card-row">
              <div className="feature-card-icon-container">
                <GiHotMeal className="feature-card-icon" />
              </div>
              <div className="feature-card-text">
                <h3 className="feature-card-title">Flexible Meal Planning</h3>
                <p>
                Includes the food you actually eat
                </p>
              </div>
            </div>
            <div className="feature-card-row">
              <div className="feature-card-icon-container">
                <RiChatPrivateFill className="feature-card-icon" />
              </div>
              <div className="feature-card-text">
                <h3 className="feature-card-title">Private Community Access</h3>
                <p>
                Peer motivation + support from others on the same journey
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}